var _path, _path2, _g, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 6.66675C8.33333 5.28604 9.45262 4.16675 10.8333 4.16675H17.0245C18.4052 4.16675 19.5245 5.28604 19.5245 6.66675V12.8444C19.5245 14.8463 17.2888 16.0362 15.6282 14.9181L15.3252 14.7141C14.4811 14.1458 13.3767 14.1458 12.5326 14.7141L12.2296 14.9181C10.569 16.0362 8.33333 14.8463 8.33333 12.8444V6.66675Z",
    fill: "#7B67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 4.16675C0 2.78604 1.11929 1.66675 2.5 1.66675H13.8773C15.258 1.66675 16.3773 2.78604 16.3773 4.16675V16.3752C16.3773 18.372 14.1519 19.5629 12.4905 18.4553L9.57538 16.5119C8.73563 15.9521 7.64163 15.9521 6.80188 16.5119L3.88675 18.4553C2.22536 19.5629 0 18.372 0 16.3752V4.16675Z",
    fill: "url(#paint0_linear_3463_4802)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6588 3.66406C16.6639 3.72543 16.6666 3.78753 16.6666 3.85024V15.0331C16.4617 14.9715 16.26 14.8773 16.0671 14.7474L15.0944 14.0924C14.3571 13.596 13.3925 13.596 12.6552 14.0924L11.6824 14.7474C10.232 15.724 8.27922 14.6847 8.27922 12.9361V5.8477C8.27922 4.64171 9.25687 3.66406 10.4629 3.66406H16.6588Z",
    fill: "#7953DD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80599 5.44824C7.96941 4.94529 8.68095 4.94529 8.84437 5.44824L9.52018 7.52817C9.59327 7.7531 9.80287 7.90539 10.0394 7.90539H12.2263C12.7552 7.90539 12.9751 8.5821 12.5472 8.89295L10.7779 10.1784C10.5866 10.3174 10.5065 10.5638 10.5796 10.7888L11.2554 12.8687C11.4188 13.3716 10.8432 13.7899 10.4154 13.479L8.64606 12.1936C8.45473 12.0546 8.19564 12.0546 8.00431 12.1936L6.23501 13.479C5.80718 13.7899 5.23153 13.3716 5.39494 12.8687L6.07075 10.7888C6.14384 10.5638 6.06378 10.3174 5.87244 10.1784L4.10315 8.89295C3.67531 8.58211 3.89519 7.90539 4.42402 7.90539H6.61099C6.84749 7.90539 7.0571 7.7531 7.13018 7.52817L7.80599 5.44824Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4802",
    x: 6.06086,
    y: 1.4457,
    width: 12.8241,
    height: 15.8962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.10918,
    result: "effect1_foregroundBlur_3463_4802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4802",
    x1: 6.101e-8,
    y1: 11.3566,
    x2: 16.3773,
    y2: 11.3566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon3);
export default __webpack_public_path__ + "static/media/navicon3.413f3347d51d17ccaff6de363c31a311.svg";
export { ForwardRef as ReactComponent };